import Locations from '@/components/locations';

export default Locations;
